<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="message"
        type="textarea"
        name="message"
        :label="$t('message')"
        :placeholder="$t('your message')"
        :rules="[{ required: true, message: $t('message is required') }]"
        :autosize="{ maxHeight: 200, minHeight: 150 }"
      />
      <van-field name="radio" :label="$t('issue type')">
        <template #input>
          <van-radio-group v-model="issueType" direction="horizontal">
            <van-radio v-for="it in issueTypes" :key="it.id" :name="it.id">
              {{ it.description }}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin: 16px; display:flex">
        <van-button round block type="info" native-type="submit">
          {{ $t("submit") }}
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "FeebackForm",
  props: {
    currentCardId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      issueType: null,
      message: ""
    };
  },
  computed: {
    ...mapState("vokabel", ["issueTypes"])
  },
  methods: {
    ...mapActions("vokabel", ["submitIssue"]),
    async onSubmit() {
      let data = {
        feedback_issue: this.issueType,
        word: this.currentCardId,
        message: this.message
      };

      try {
        await this.submitIssue(data);
        this.$notify({
          type: "success",
          message: this.$t("feedback.thanks")
        });
        this.$emit("feedbackdone");
      } catch {
        this.$notify({
          type: "danger",
          message: this.$t("feedback.errSubmitAgain")
        });
      }
    }
  },
  mounted() {
    this.issueType = this.issueTypes[0].id;
  }
};
</script>
